import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailers-select_quantity_dropdown-click';
/**
 * Fires when retailer selects a quantity using the dropdown on the PDP Picker.

Parameter: Value selected
*/
export function trackRetailersSelectQuantityDropdownClick(customParameterToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { customParameterToken },
    });
}
